"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RazorpayService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
let JSONbig = require('json-bigint')({ useNativeBigInt: true });
class RazorpayService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    createOrder(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'razorpay/create';
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.post((url = url), payload, {
                    headers: header,
                });
                return response.data;
            }
            catch (error) {
                throw new Error("Error in creating order");
            }
        });
    }
}
exports.RazorpayService = RazorpayService;
